<template>
    <div class="alerts alerts--fixed">
        <div class="container">
            <div class="errors">
                <div
                    v-for="(item,index) in errors"
                    :key="index"
                    :class="{ active: active.errors }">

                    {{item}}
                </div>
            </div>
            <div class="warnings">
                <div
                    v-for="(item,index) in warnings"
                    :key="index"
                    :class="{ active: active.warnings }">

                    {{item}}
                </div>
            </div>
            <div class="success">
                <div
                    v-for="(item,index) in success"
                    :key="index"
                    :class="{ active: active.success }">

                    {{item}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            active: {
                warnings: false,
                success: false,
                errors: false
            },
            intervals: {
                warnings: { div: null, text: null },
                success: { div: null, text: null },
                errors: { div: null, text: null }
            }
        }
    },
    computed: {
        warnings_length() {
            return this.$store.state.flashs.warnings.length;
        },
        warnings() {
            return this.$store.state.flashs.warnings;
        },
        success_length() {
            return this.$store.state.flashs.success.length;
        },
        success() {
            return this.$store.state.flashs.success;
        },
        errors_length() {
            return this.$store.state.flashs.errors.length;
        },
        errors() {
            return this.$store.state.flashs.errors;
        }
    },
    watch: {
        warnings_length() {
            this.show('warnings');
        },
        success_length() {
            this.show('success');
        },
        errors_length() {
            this.show('errors');
        },
    },
    methods: {
        show( type ){
            switch (type){
                case 'warnings':
                    this.active.warnings = true;
                    this.close(type);
                    break;
                case 'success':
                    this.active.success = true;
                    this.close(type);
                    break;
                default:
                    this.active.errors = true;
                    this.close(type);
            }
        },
        close(type){
            clearTimeout(this.intervals[type].div)
            clearTimeout(this.intervals[type].text)
            this.intervals[type].div = setTimeout(function(){
                this.active[type] = false;
            }.bind(this), 5000);
            this.intervals[type].text = setTimeout(function(){
                this.$store.commit(
                    'flash_clear',
                    type
                );
            }.bind(this), 6000);
        }
    }
}
</script>

<style lang="scss">
.alerts {
    &--fixed {
        position: fixed;
        z-index: 1000;
        top: 20px;
        right: 20px;
        left: 20px;
        @media (min-width: 768px) {
            width: 400px;
            left: auto;
        }
    }
}

.errors div,
.success div,
.warnings div {
    margin: 0 auto 0 auto;
    max-width: calc(100% - 32px);
    position: relative;
    background-color: #ff8f00;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0 20px;
    display: block;
    height: auto;
    max-height: 0;
    overflow: hidden;
    border-radius: 3px;
    opacity: 0;
    color: #ffffff;
    font-weight: 700;
    transition:
        opacity .3s,
        max-height .8s,
        padding .8s,
        margin .3s;

    &.active {
        max-height: 70px;
        padding: 10px 20px;
        opacity: 1;
        margin: 0 auto 5px auto;
    }
}
.success div {
    background-color: #00b107;
}
.errors div {
    background-color: #ff0039;
}

</style>
